import _ from 'lodash';
import React from 'react';

import { useTable, useSortBy, usePagination, useFilters, useGlobalFilter, useAsyncDebounce } from 'react-table'

const defaultPropGetter = () => ({});
export function TableComponent({ 
	tableCols,
	data, 
	initialState,
	setState,
	getHeaderProps = defaultPropGetter,
	getColumnProps = defaultPropGetter,
	getRowProps = defaultPropGetter,
	getCellProps = defaultPropGetter,
}) {

	const columns = React.useMemo(
		() => tableCols, []
	)

	const filterTypes = React.useMemo(
		() => ({
		//   // Add a new fuzzyTextFilterFn filter type.
		//   fuzzyText: fuzzyTextFilterFn,
		//   // Or, override the default text filter to use
		//   // "startWith"
		//   text: (rows, id, filterValue) => {
		// 	return rows.filter(row => {
		// 	  const rowValue = row.values[id]
		// 	  return rowValue !== undefined
		// 		? String(rowValue)
		// 			.toLowerCase()
		// 			.startsWith(String(filterValue).toLowerCase())
		// 		: true
		// 	})
		//   },
		}),
		[]
	  )

	const defaultColumn = React.useMemo(
		() => ({
		  // Let's set up our default Filter UI
		  Filter: DefaultColumnFilter,
		}),
		[]
	  )

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,
		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		setPageSize,
		state,
		state: { pageIndex, pageSize },
		visibleColumns,
		preGlobalFilteredRows,
		setGlobalFilter,
		TheadComponent={TheadComponent},
		
		
		} = useTable(
			{
				columns,
				data,
				initialState,
				defaultColumn,
				filterTypes,
				
				// useControlledState: state => {
				// 	return React.useMemo(
				// 	  () => ({
				// 		...state,
				// 		filtersVisible: !state.filtersVisible,
				// 	  }),
				// 	  [state]
				// 	)
				//   },
				// useControlledState: state => {
				// 	return { ...state, filtersVisible: !state.filtersVisible };
				// },

			},
			
			useFilters,
			useGlobalFilter,
			useSortBy,
			usePagination,			
	)
  
	//const firstPageRows = rows.slice(0,20) // pagination....
	// const firstPageRows = rows
//column.getSortByToggleProps()
	return (
	  <>
		<table {...getTableProps()}>
		  <thead>
		  	<tr>
				<th
				colSpan={visibleColumns.length}
				style={{
					textAlign: 'left',
				}}
				>
					{/* React.useState(globalFilter) */}
				{/* <button onClick={(data) => state.filtersVisible ? this.setState({filtersVisible: false}) : this.setState({filtersVisible: true})} >{(state.filtersVisible ? 'Close' : 'Open') + ' Advanced Filtering'}</button> */}

				{/* <button onClick={() => {setState({filtersVisible: !state.filtersVisible})}} >{(state.filtersVisible ? 'Hide' : 'Show') + ' Advanced Filtering '}</button> */}

				{/* <GlobalFilter
					preGlobalFilteredRows={preGlobalFilteredRows}
					globalFilter={state.globalFilter}
					setGlobalFilter={setGlobalFilter}
				/> */}
				</th>
			</tr>
			{headerGroups.map(headerGroup => 
			  (<tr {...headerGroup.getHeaderGroupProps()}>
				{headerGroup.headers.map(column => column.Header ? (
				  <th {...column.getHeaderProps()}  style={{'padding': '1px'}}>
					<div {...column.getHeaderProps([column.getSortByToggleProps(), getColumnProps(column)])} >
						{column.Header ? column.render('Header') : ''}
						{/* {column.render('Header')} */}
						<span>&nbsp;{
							column.isSorted
								? column.isSortedDesc ? <i className="fas fa-sort-down" /> : <i className="fas fa-sort-up" />
								: ''
						}</span>
					</div>
				  </th>
				) : null )}
			  </tr>
			))}
			{headerGroups.map(headerGroup => 
			  (<tr {...headerGroup.getHeaderGroupProps()}>
				{headerGroup.headers.map(column => column.Header ? (
				  <th {...column.getHeaderProps()}  style={{'padding': '1px'}}>
					<div>{
						state.filtersVisible 
							? (column.canFilter ? column.render('Filter') : null)
							: null
					}</div>
				  </th>
				) : null )}
			  </tr>
			))}
		  </thead>
		  <tbody {...getTableBodyProps()}>
			{page.map((row, i) => {
				prepareRow(row)
				return (
				<tr {...row.getRowProps(getRowProps(row))}>
					{row.cells.map(cell => {
					return <td {...cell.getCellProps([
						// {
						//   className: cell.column.className,
						//   style: cell.column.style,
						// },
						getColumnProps(cell.column),
						getCellProps(cell),
					  ])}>{cell.render('Cell')}</td>
					})}
				</tr>
				)
			})}
		  </tbody>
		</table>

		<div>
			<button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
				<i className="fas fa-arrow-to-left" />
			</button>
			&nbsp;
			<button onClick={() => previousPage()} disabled={!canPreviousPage}>
				<i className="fas fa-arrow-left" />
			</button>
			&nbsp;
			<span>
				Page&nbsp;<strong> {pageIndex + 1} of {pageOptions.length} </strong>
			</span>
			&nbsp;
			<button onClick={() => nextPage()} disabled={!canNextPage}>
				<i className="fas fa-arrow-right" />
			</button>
			&nbsp;
			<button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
				<i className="fas fa-arrow-to-right" />
			</button>{' '}
		</div>
		<br />
		<div>
			<select
				className="grid-selectbox"
				value={pageSize}
				onChange={e => {
					setPageSize(Number(e.target.value))
				}}
				style={{ width: '9vw', display: 'inline' }}
			>
				{[10, 20, 30, 40, 50].map(pageSize => (
					<option key={pageSize} value={pageSize}>
					Show {pageSize}
					</option>
				))}
			</select>
			&nbsp;
			<span>
				Go to page:&nbsp;
				<input
					type="number"
					className="grid-spinner"
					defaultValue={pageIndex + 1}
					onChange={e => {
					const page = e.target.value ? Number(e.target.value) - 1 : 0
					gotoPage(page)
					}}
					style={{ width: '100px', display: 'inline' }}
				/>
			</span>

		</div>


		{/* DEBUG!!! */}
		{/* <pre>{JSON.stringify(state, null, 2)}</pre> */}
    
	  </>
	)
}

function toggleFiltersVisible(state) {
	console.log(state.filtersVisible )
	// const [value, setValue] = React.useState(filtersVisible)
	// console.log(value )
	return (state.filtersVisible = !state.filtersVisible)
	// return (state.filtersVisible ? state.filtersVisible = false : state.filtersVisible = true)
	
}

export function GlobalFilter({
	preGlobalFilteredRows,
	globalFilter,
	setGlobalFilter,
  }) {
	const count = preGlobalFilteredRows.length
	const [value, setValue] = React.useState(globalFilter)
	const onChange = useAsyncDebounce(value => {
	  setGlobalFilter(value || undefined)
	}, 200)
  
	return (
	  <span>
		<input
		  value={value || ""}
		  onChange={e => {
			setValue(e.target.value);
			onChange(e.target.value);
		  }}
		  placeholder={`Global Search`}
		  style={{
			fontSize: '1.1rem',
			border: '0',
		  }}
		/>
	  </span>
	)
  }

function DefaultColumnFilter({
	column: { filterValue, preFilteredRows, setFilter },
  }) {
	const count = preFilteredRows.length
  
	return (
	  <input
		value={filterValue || ''}
		onChange={e => {
		  setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
		}}
		placeholder={`Search ${count} records...`}
	  />
	)
  }

export function SelectColumnFilter({
	column: { filterValue, setFilter, preFilteredRows, id },
  }) {
	// Calculate the options for filtering
	// using the preFilteredRows
	const options = React.useMemo(() => {
	  const options = new Set()
	  preFilteredRows.forEach(row => {
		options.add(row.values[id])
	  })
	  return [...options.values()]
	}, [id, preFilteredRows])
  
	// Render a multi-select box
	return (
	  <select
		className="grid-selectbox"
		value={filterValue}
		onChange={e => {
		  setFilter(e.target.value || undefined)
		}}
	  >
		<option value="">All</option>
		{options.map((option, i) => (
		  <option key={i} value={option}>
			{option}
		  </option>
		))}
	  </select>
	)
  }

  export function SliderColumnFilter({
	column: { filterValue, setFilter, preFilteredRows, id },
  }) {
	// Calculate the min and max
	// using the preFilteredRows
  
	const [min, max] = React.useMemo(() => {
	  let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
	  let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
	  preFilteredRows.forEach(row => {
		min = Math.min(row.values[id], min)
		max = Math.max(row.values[id], max)
	  })
	  return [min, max]
	}, [id, preFilteredRows])
  
	return (
	  <>
		<input
			className="grid-spinner"
			type="range"
			min={min}
			max={max}
			value={filterValue || min}
			onChange={e => {
				setFilter(parseInt(e.target.value, 10))
			}}
		/>
		<button onClick={() => setFilter(undefined)}>Off</button>
	  </>
	)
  }

  export function NumberRangeColumnFilter({
	column: { filterValue = [], preFilteredRows, setFilter, id },
  }) {
	const [min, max] = React.useMemo(() => {
	  let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
	  let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
	  preFilteredRows.forEach(row => {
		min = Math.min(row.values[id], min)
		max = Math.max(row.values[id], max)
	  })
	  return [min, max]
	}, [id, preFilteredRows])
  
	return (
	  <div
		style={{
		  display: 'flex',
		}}
	  >
		<input
		  value={filterValue[0] || ''}
		  min={min}
		  className="grid-spinner"
		  type="number"
		  onChange={e => {
			const val = e.target.value
			setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
		  }}
		  placeholder={`Min`}
		  style={{
			width: '70px',
			marginRight: '0.5rem',
		  }}
		/>
		to
		<input
		  value={filterValue[1] || ''}
		  min={min}
		  max={max}
		  className="grid-spinner"
		  type="number"
		  onChange={e => {
			const val = e.target.value
			setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
		  }}
		  placeholder={`Max`}
		  style={{
			width: '70px',
			marginLeft: '0.5rem',
		  }}
		/>
	  </div>
	)
  }

export function calcTimeSince(dateFrom, {verbose=true, timeType='AUTO'}={}) {
	// verbose:
	// true = number with words -- x yrs, x mos, etc....
	// false = just a number -- 23, 99, etc...
	//
	//	timeType:
	// 'MS' = millisecs since
	// 'AUTO' = auto picks based on settings below
	const autoSettings = {
		'YEARS': 31536000000, // 1 year: 31536000000 MS
		'MONTHS': 7776000000, // 90 days: 7776000000 MS
		'DAYS': 172800000, // 2 days: 172800000 MS (1 day = 86400000 MS)
		'HOURS': 3600000 , // 1 hour: 3600000 MS
		'MINUTES': 60000, // 1 minute: 60000 MS
		'SECONDS': 1000 // 1 second: 1000 MS
	}

	if (dateFrom instanceof Date == false) {
		dateFrom = new Date(dateFrom)
	}
	const dateTo = new Date();
	const diff_ms = dateTo.getTime() - dateFrom.getTime();
	if (timeType == 'MS') {
		return diff_ms  + (verbose ? " MS" : 0);
	} else if ((timeType=='YEARS') || (timeType=='AUTO' && diff_ms > autoSettings['YEARS'])) {
		return Math.abs(new Date(diff_ms).getUTCFullYear() - 1970) + (verbose ? " yrs" : 0);
	} else if ((timeType=='MONTHS') || (timeType=='AUTO' && diff_ms > autoSettings['MONTHS'])) { 
		return dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear())) + (verbose ? " mos" : 0);
	} else if ((timeType=='DAYS') || (timeType=='AUTO' && diff_ms > autoSettings['DAYS'])) { 
		return Math.round(diff_ms/86400000) + (verbose ? " days" : 0);
	} else if ((timeType=='HOURS') || (timeType=='AUTO' && diff_ms > autoSettings['HOURS'])) { 
		return Math.round(diff_ms/3600000) + (verbose ? " hrs" : 0);
	} else if ((timeType=='MINUTES') || (timeType=='AUTO' && diff_ms > autoSettings['MINUTES'])) { 
		return Math.round(diff_ms/60000) + (verbose ? " mins" : 0);
	} else {
		return Math.round(diff_ms/1000) + (verbose ? " secs" : 0);
	}

}


export default TableComponent;